// function getStroreAddress(obj, basePath) {
//     var storeCity = $.trim($(obj).val());
// 	$('#fldStoreAddress').html('<option value="">Please select an address</option>');
	
//     if(storeCity) {
// 	    dataString = 'storeCity=' + storeCity ;

//         $.ajax({
//             type: "POST",
//             url: basePath+'getStroreAddress.php',
//             data: dataString,
//             cache: false,
//             success: function (responseStr) {
//                 $('#fldStoreAddress').html(responseStr);
//             }
//         });
//     }
// }

function getStroreAddress(obj) {
    var storeCity = obj.value;
	if(storeCity == 'Oakbrook, IL'){
		$('#fldStoreAddress').html('<option value="">Please select an address</option><option selected="selected" value="298 Oakbrook Center, Oak Brook, IL 60523">298 Oakbrook Center, Oak Brook, IL 60523</option>');
	}
}

function validateContact(actionFrom = '') {

	var ctpageOrigin = document.contactForm.pageOrigin.value;
    var ctfldSex = document.contactForm.fldSex.value.trim();
    var ctFirstName = document.contactForm.fldFirstName.value.trim();
    var ctLastName = document.contactForm.fldLastName.value.trim();
    var ctEmail = document.contactForm.fldEmail.value.trim();
    var ctStdCode = document.contactForm.fldStdCode.value.trim();
    var ctPhone = document.contactForm.fldPhone.value.trim();
    var ctMessage = document.contactForm.fldMessage.value.trim();

    var fldCountryResidense = document.contactForm.fldCountryResidense.value.trim();
    var fldStoreCountry = document.contactForm.fldStoreCountry.value.trim();
    var fldStoreCity = document.contactForm.fldStoreCity.value.trim();
    var ctStoreAddress = document.contactForm.fldStoreAddress.value.trim();
	var storeID = $('#fldStoreAddress option:selected').attr('data-store-id');

    var ctCheckPolicy = document.contactForm.fldCheckPolicy.checked;
    var ctCheckConsent = document.contactForm.fldUserConsent.checked;

    validate = true;
    errorCount = 0;

    $('.requiredField').each(function() {
        value = $.trim($(this).val());
        fldID = $(this).attr('id');
        fldDivClass = fldID+'-class';

        if(value == '') {
            errorCount++;
            $('.'+fldDivClass).addClass('msgYes');
        }else {
            $('.'+fldDivClass).removeClass('msgYes');
        }
    });

    if (ctEmail === '' || ctPhone === '') {
		// Show error if either field is empty
		if (ctEmail === '') {
			$(".fldEmail-class").addClass('msgYes');
			errorCount++;
		} else {
			$(".fldEmail-class").removeClass('msgYes');
		}

		if (ctPhone === '') {
			$(".fldPhone-class").addClass('msgYes');
			errorCount++;
		} else {
			$(".fldPhone-class").removeClass('msgYes');
		}
	} else {
		// Validate email format
		let emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if (!emailRegex.test(ctEmail.trim())) {
			$(".fldEmail-class").addClass('msgYes');
			errorCount++;
		} else {
			$(".fldEmail-class").removeClass('msgYes');
		}

		// Validate phone format
		let phoneRegex = /^[0-9()\-\s]+$/;
		if (!phoneRegex.test(ctPhone.trim())) {
			$(".fldPhone-class").addClass('msgYes');
			errorCount++;
		} else {
			$(".fldPhone-class").removeClass('msgYes');
		}
	}
    
	// Privacy Policy
    if (!ctCheckPolicy) {                
        $('.policyClass').show();
        document.contactForm.fldCheckPolicy.focus();
        errorCount++;
    }else {
        $('.policyClass').hide();
    }

	// User Consent
    if (!ctCheckConsent) {                
        $('.consentClass').show();
        document.contactForm.fldUserConsent.focus();
        errorCount++;
    }else {
        $('.consentClass').hide();
    }

    if(errorCount == 0) {
        validate = true;
    }else {
        validate = false;
    }

    if(validate == false) return false;

    //alert(errorCount);

    /*if (!$("#fldEmail").val().match(/^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/)) {
		$("#fldEmail").focus();
		valid = false;
    }*/

    var dataString = 'ctpageOrigin='+ ctpageOrigin + '&ctfldSex='+ ctfldSex + '&ctFirstName='+ ctFirstName + '&ctLastName='+ ctLastName + '&ctEmail='+ ctEmail + '&ctStdCode='+ ctStdCode + '&ctPhone='+ ctPhone + '&ctMessage='+ ctMessage + '&ctCheckPolicy=' + ctCheckPolicy + '&ctCheckConsent=' + ctCheckConsent  + '&fldCountryResidense='+ encodeURI(fldCountryResidense)  + '&fldStoreCountry='+ encodeURI(fldStoreCountry)  + '&fldStoreCity='+ encodeURI(fldStoreCity) + '&ctStoreAddress='+ encodeURI(ctStoreAddress) + '&storeID='+ encodeURI(storeID) + '&g-recaptcha-response=' +$('#g-recaptcha-response').val();

    url = 'https://shopify-admin.bluestar-apps.com/cdpeacock/api/send-contact-email-rcpo.php';

    $.ajax({
        type: "POST",
        url: url,
        data: dataString,
        cache: false,
        success: function(responseStr){
			$('#formContainer').hide();	
			$('#thankyouContainer').show();	
			$('#contactForm').trigger('reset');
			
			scollToDiv('formSectionContainer', -80);
			
			if(actionFrom == '') {
				_satellite.track('contactForm');
				window.location.href = "/pages/rolex-cpo-thankyou.html"; 
			}else {
				_satellite.track('contactForm');
				//window.location.href = "/pages/rolex-cpo-thankyou-contact.html"; 
			}
        }
    });
};

function scollToDiv(){
    //const targetDiv = document.getElementById("formSectionContainer");
    //targetDiv.scrollIntoView({ behavior: "smooth" });
    
    const targetDiv = document.getElementById("thankyouContainer");
    const currentScrollY = window.pageYOffset;

    const targetDivRect = targetDiv.getBoundingClientRect();
    const targetDivTop = targetDivRect.top;

    const parentDiv = targetDiv.parentElement;
    const parentScrollY = parentDiv.scrollTop || 0;  // Handle potential absence of scrollTop

    const finalScrollY = targetDivTop + currentScrollY + parentScrollY - 180;
    //alert(finalScrollY);

    window.scrollTo({ top: finalScrollY, behavior: "smooth" });
}

document.addEventListener("DOMContentLoaded", function () {
    const textarea = document.querySelector(".myTextareaModal"); // Select the first element with the class
    const fixedText = textarea.placeholder; // Get the placeholder value

    // Ensure the initial value is set to fixedText
    textarea.value = fixedText;

    // Prevent editing of the fixed text
    textarea.addEventListener("input", function () {
        if (!textarea.value.startsWith(fixedText)) {
            textarea.value = fixedText + textarea.value.substring(fixedText.length);
        }
    });

    // Place the cursor after the fixed text on focus
    textarea.addEventListener("focus", function () {
        textarea.setSelectionRange(fixedText.length, fixedText.length);
    });

    // Prevent cursor placement inside the fixed text
    textarea.addEventListener("click", function () {
        if (textarea.selectionStart < fixedText.length) {
            textarea.setSelectionRange(fixedText.length, fixedText.length);
        }
    });

    // Ensure keyboard navigation doesn't enter the fixed text
    textarea.addEventListener("keydown", function (event) {
        if (
            (textarea.selectionStart < fixedText.length || textarea.selectionEnd < fixedText.length) &&
            !["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"].includes(event.key)
        ) {
            event.preventDefault();
            textarea.setSelectionRange(fixedText.length, fixedText.length);
        }
    });
});

    if (document.documentElement.clientWidth <= 990) {
        $('.rolexNavList > li.dropDownclick > a').click(function() {
            $('.dropdown-menu').toggleClass('showNav')
        })
    }
    $('.filter-icon').click(function() {
        $('.collection-watches .leftFilter').addClass('showLeftsection')
        $('body').addClass('scrollNone')
    });
    $('.collection-watches .leftFilter .closeFilter').click(function() {
        $('.leftFilter').removeClass('showLeftsection')
        $('body').removeClass('scrollNone')
    });
    $('.collection-watches .leftFilter .viewResult').click(function() {
        $('#workingDiv').show();
        $('.leftFilter').removeClass('showLeftsection')
        $('body').removeClass('scrollNone')
        setTimeout(function() {
            $("html, body").animate({
                scrollTop: $("#collection_main_container").offset().top
            }, "slow");
        }, 500);
        $('#workingDiv').hide();
    });



      

            var galleryThumbs = new Swiper('.gallery-thumbs', {
                spaceBetween: 4,
                slidesPerView: 4,
                allowTouchMove: false,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
            });
            var galleryTop = new Swiper('.gallery-top', {
                spaceBetween: 0,
                pagination: {
                    el: '.swiper-pagination1',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next1',
                    prevEl: '.swiper-button-prev1',
                },
                breakpoints: {
                    990: {
                        slidesPerView: 1,
                        slidesPerGroup: 1
                    }
                },
                thumbs: {
                    swiper: galleryThumbs
                }
            });



            function showcontactus(){

    $('#workingDiv').show();

    $('html, body').animate({scrollTop: $("#contactFormBanner").offset().top }, 500);

    $('#workingDiv').hide();

}